export function transformStringToRegex(string: string, flags?: string): RegExp {
  string = string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  return new RegExp(string, flags);
}
